module.exports = __webpack_public_path__ + "img/logo_top_new.dd80e2a9.png";